module.exports = __webpack_public_path__ + "static/media/cq_tutti_option b.a50723b2.svg";